import { render } from "./WhatsAppBroadcastView.vue?vue&type=template&id=0cf09985&scoped=true"
import script from "./WhatsAppBroadcastView.vue?vue&type=script&lang=js"
export * from "./WhatsAppBroadcastView.vue?vue&type=script&lang=js"

import "./WhatsAppBroadcastView.vue?vue&type=style&index=0&id=0cf09985&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0cf09985"]])

export default __exports__